export function  renderObservacao (item) {
    if (item.adicionalObs) {
        return `<strong>OBS:</strong> ${item.adicionalObs}`
    }
}